export default __webpack_public_path__ + "static/media/safety-certificate.958c8910.svg";